// extracted by mini-css-extract-plugin
module.exports = {"userProfileCard":"UserCard_userProfileCard__2p70k","userProfile":"UserCard_userProfile__2Ndt1","avatar":"UserCard_avatar__1nrW2","logOut":"UserCard_logOut__2hdNy"};